import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { useDirtyState } from "../../hooks/useDirtyState";
import { DirtyStateDialog } from "../shared/DirtyStateDialog";

const EditPredictor = ({ editPredictor, setEditPredictor, handleUpdate }) => {
    const { markDirty, resetDirty, showDialog, confirmNavigation, cancelNavigation } = useDirtyState(editPredictor);

    const handleInputChange = (field, value) => {
        setEditPredictor(prev => {
            const updated = { ...prev, [field]: value };
            markDirty(updated);
            return updated;
        });
    };

    const handleClose = () => {
        setEditPredictor(null);
        resetDirty();
    };

    const handleSubmit = () => {
        handleUpdate();
        resetDirty();
    };

    return (
        <>
            <Card className="mt-6">
                <CardHeader>
                    <CardTitle>Modifier le Prédicteur</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                        <div className="grid w-full gap-1.5">
                            <Label htmlFor="edit-predictor-name">Nom du prédicteur</Label>
                            <Input
                                id="edit-predictor-name"
                                type="text"
                                placeholder="Nom du prédicteur"
                                value={editPredictor.predictorname}
                                onChange={(e) => handleInputChange('predictorname', e.target.value)}
                            />
                        </div>
                        <div className="grid w-full gap-1.5">
                            <Label htmlFor="edit-predictor-score">Score de compétence</Label>
                            <Input
                                id="edit-predictor-score"
                                type="number"
                                placeholder="Score de compétence"
                                value={editPredictor.proficiency_score}
                                onChange={(e) => handleInputChange('proficiency_score', e.target.value)}
                            />
                        </div>
                        <div className="flex gap-2 md:col-span-2">
                            <Button onClick={handleSubmit} size="sm">Enregistrer</Button>
                            <Button variant="outline" size="sm" onClick={handleClose}>
                                Annuler
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
            <DirtyStateDialog open={showDialog} onConfirm={confirmNavigation} onCancel={cancelNavigation} />
        </>
    );
};

export default EditPredictor;
